import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { contactApi } from "../api/contactApi";

export default function ContactList() {
  const nav = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  const load = async () => {
    setLoading(true);
    setErr("");
    try {
      const res = await contactApi.list();
      setItems(res.data || []);
    } catch (e) {
      setErr(e?.response?.data || e.message || "Load failed");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const formatDateTime = (v) => {
    if (!v) return "-";
    const dt = new Date(v);
    if (Number.isNaN(dt.getTime())) return "-";

    // ✅ +4 saat əlavə et (günü aşsa avtomatik növbəti günə keçir)
    dt.setHours(dt.getHours() + 4);

    const dd = String(dt.getDate()).padStart(2, "0");
    const mm = String(dt.getMonth() + 1).padStart(2, "0");
    const yyyy = dt.getFullYear();

    const hh = String(dt.getHours()).padStart(2, "0");
    const mi = String(dt.getMinutes()).padStart(2, "0");

    return `${dd}.${mm}.${yyyy} ${hh}:${mi}`;
  };

  const toggleRead = async (id, isRead) => {
    try {
      await contactApi.setRead(id, !isRead);
      await load();
    } catch (e) {
      alert(e?.response?.data || e.message || "Update failed");
    }
  };

  const del = async (id) => {
    if (!window.confirm("Silinsin?")) return;
    try {
      await contactApi.remove(id);
      await load();
    } catch (e) {
      alert(e?.response?.data || e.message || "Delete failed");
    }
  };

  if (loading)
    return (
      <div className="card">
        <div className="cardBody">Yüklənir...</div>
      </div>
    );
  if (err)
    return (
      <div className="card">
        <div className="cardBody" style={{ color: "rgba(255,77,79,.9)" }}>
          {String(err)}
        </div>
      </div>
    );

  return (
    <div>
      <h1 className="pageTitle">Mesajlar</h1>

      <div className="card">
        <div className="cardBody" style={{ overflowX: "auto" }}>
          <table className="table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Daxilolma tarixi</th>
                <th>Ad və Soyad</th>
                <th>Email</th>
                <th>Status</th>
                <th>Mesaj</th>
                <th style={{ width: 260 }}>Əməliyyat</th>
              </tr>
            </thead>
            <tbody>
              {items.map((x, index) => (
                <tr key={x.id}>
                  <td>{index + 1}</td>
                  <td style={{ whiteSpace: "nowrap" }}>
                    {formatDateTime(x.createDateUtc)}
                  </td>

                  <td>{x.name}</td>
                  <td>{x.email}</td>
                  <td>
                    {x.isRead ? (
                      <span className="badge badgeOk">Oxundu</span>
                    ) : (
                      <span className="badge badgeNo">Yeni</span>
                    )}
                  </td>
                  <td style={{ maxWidth: 420 }}>{x.preview}</td>
                  <td style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                    {/* <button className="btn btnPrimary" onClick={() => nav(`/contacts/${x.id}`)}>Aç</button> */}
                    <button
                      className="btn"
                      onClick={() => toggleRead(x.id, x.isRead)}
                    >
                      {x.isRead ? "Mark Unread" : "Mark Read"}
                    </button>
                    <button className="btn btnDanger" onClick={() => del(x.id)}>
                      Sil
                    </button>
                  </td>
                </tr>
              ))}
              {items.length === 0 && (
                <tr>
                  <td colSpan={7} style={{ opacity: 0.7, fontWeight: 700 }}>
                    Mesaj yoxdur
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
